import { Injectable } from '@angular/core';
import { SourceName, StorageKeys } from '@core/enums';
import { IUserProfileResponse } from '@core/interface';

@Injectable({
  providedIn: 'root'
})
export class ValidateUserService {
  validateUserProfile(): boolean {
    const userProfileString = sessionStorage.getItem(StorageKeys.USER_PROFILE);

    if (!userProfileString) {
      console.warn('userProfile não encontrado no sessionStorage');
      return false;
    }

    try {
      const userProfile = JSON.parse(userProfileString) as IUserProfileResponse;

      if (!userProfile.address?.postalCode || userProfile.address.postalCode === '') {
        console.warn('userProfile.address.postalCode está vazio');
        return false;
      }

      if (!userProfile.address?.addressLine1 || userProfile.address.addressLine1 === '') {
        console.warn('userProfile.address.addressLine1 está vazio');
        return false;
      }

      return true;
    } catch (error) {
      console.error('Erro ao fazer parse do userProfile:', error);
      return false;
    }
  }

  validateUserVehicles(): boolean {
    const userVehiclesString = sessionStorage.getItem(StorageKeys.USER_VEHICLES);

    if (!userVehiclesString) {
      console.warn('userVehicles não encontrado no sessionStorage');
      return false;
    }

    try {
      const userVehicles = JSON.parse(userVehiclesString);

      if (!Array.isArray(userVehicles) || userVehicles.length === 0) {
        console.warn('userVehicles deve ser um array não vazio');
        return false;
      }

      return true;
    } catch (error) {
      console.error('Erro ao fazer parse do userVehicles:', error);
      return false;
    }
  }

  isMyFordAccountURL(): boolean {
    return sessionStorage.getItem(StorageKeys.ORIGIN_URL) === SourceName.mfa;
  }

  isPerksFordPassURL(): boolean {
    return sessionStorage.getItem(StorageKeys.ORIGIN_URL) === SourceName.perksFordpass;
  }
}
